import { FC, useMemo } from 'react';
import { useSingleCourse } from '@new/features/courses/contexts/SingleCourseProvider';

const STEP_GAPS_OFFSET = 1;
const HALF_STEP_WIDTH_PERCENT = 50;
const STEPS_LENGTH = 4;

export const StepProgressBar: FC = () => {
  const { course } = useSingleCourse();

  const courseComplete = course?.coursePassed ?? false;
  const projectComplete = (course?.projectCompleted ?? false) || courseComplete;
  const examComplete = (course?.quizCompleted ?? false) || projectComplete;
  const selfAssessmentComplete = course?.selfAssessmentCompletionPercentage === 100 || examComplete;

  const stepsCompletedCount = [
    selfAssessmentComplete,
    examComplete,
    projectComplete,
    courseComplete,
  ].filter(Boolean).length;

  const percentage = useMemo(() => {
    if (stepsCompletedCount === 0) return 0;
    const totalGaps = STEPS_LENGTH - STEP_GAPS_OFFSET;
    const completedGaps = stepsCompletedCount - STEP_GAPS_OFFSET;
    return (completedGaps / totalGaps) * 100;
  }, [stepsCompletedCount]);

  const barPosition = `calc(${HALF_STEP_WIDTH_PERCENT}% / ${STEPS_LENGTH})`;

  return (
    <div
      className="absolute top-9 h-0.5 bg-(--neutral-white-NW800) z-0"
      style={{
        left: barPosition,
        right: barPosition,
      }}
    >
      <div
        className="h-full transition-all duration-300 bg-(--success-S600)"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};
